import { useQuery } from "@tanstack/react-query";
import { QA_API_DOMAIN, fetchWithSupabaseAuth } from "@/api/classifier";

export interface UnmatchedLeadTerm {
  leadTerm: string;
  evidenceQuotes: Array<{
    text: string;
    s3Key: string;
    fileIdentifier: string;
  }>;
  anatomicalLocations: string[];
  termChain: Array<{
    level: number;
    term: string;
    icd10Codes: string[];
    selectedAsMainTerm: boolean;
    evaluatedSubTerms: string[];
    debugInfo: string | null;
  }>;
  langfuseTraceId: string | null;
  langfuseSpanId: string | null;
}

async function fetchUnmatchedLeadTerms(classificationResultId: string): Promise<UnmatchedLeadTerm[]> {
  const response = await fetchWithSupabaseAuth(`${QA_API_DOMAIN}/unmatched-lead-terms/${classificationResultId}`);
  if (!response.ok) throw new Error("Failed to fetch unmatched lead terms");
  const data = await response.json();
  return data.unmatchedLeadTerms;
}

export function useUnmatchedLeadTerms(classificationResultId: string | undefined) {
  return useQuery({
    queryKey: ["unmatched-lead-terms", classificationResultId],
    queryFn: () => fetchUnmatchedLeadTerms(classificationResultId!),
    enabled: !!classificationResultId,
  });
}
